import React, { FC } from "react";
import { useTranslation } from "react-i18next";
import { GetTypographyContent } from "../shared/Typography/Typography";
import {
  CreateAccountPasswordRequirmentsContainer,
  CreateAccountPasswordRequirmentsRow,
  CreateAccountPasswordRequirmentsTitle,
  CreateAccountStyledCheckMark,
} from "./CreateAccountForm.styles";

interface CreateAccountPasswordInfoProps {
  isPw8Chars: boolean;
  isPwUpperChar: boolean;
  isPwLowerChar: boolean;
  isPwDigit: boolean;
  isFlatLayout?: boolean;
}

export const CreateAccountPasswordInfo: FC<CreateAccountPasswordInfoProps> = ({
  isPw8Chars,
  isPwUpperChar,
  isPwLowerChar,
  isPwDigit,
  isFlatLayout,
}) => {
  const { t } = useTranslation();

  return (
    <>
      <CreateAccountPasswordRequirmentsTitle>
        {GetTypographyContent({
          content: t("createAccount.password.requirementsTitle"),
          size: "medium",
          isBold: true,
          textColor: "greyBase",
        })}
        <CreateAccountPasswordRequirmentsContainer flat={isFlatLayout}>
          <CreateAccountPasswordRequirmentsRow>
            <CreateAccountStyledCheckMark $valid={isPw8Chars} />
            {GetTypographyContent({
              content: t("createAccount.password.requirements.minLength"),
              size: "small",
              textColor: "greyBase",
            })}
          </CreateAccountPasswordRequirmentsRow>
          <CreateAccountPasswordRequirmentsRow>
            <CreateAccountStyledCheckMark $valid={isPwUpperChar} />
            {GetTypographyContent({
              content: t("createAccount.password.requirements.uppercase"),
              size: "small",
              textColor: "greyBase",
            })}
          </CreateAccountPasswordRequirmentsRow>
        </CreateAccountPasswordRequirmentsContainer>
        <CreateAccountPasswordRequirmentsContainer flat={isFlatLayout}>
          <CreateAccountPasswordRequirmentsRow>
            <CreateAccountStyledCheckMark $valid={isPwLowerChar} />
            {GetTypographyContent({
              content: t("createAccount.password.requirements.lowercase"),
              size: "small",
              textColor: "greyBase",
            })}
          </CreateAccountPasswordRequirmentsRow>
          <CreateAccountPasswordRequirmentsRow>
            <CreateAccountStyledCheckMark $valid={isPwDigit} />
            {GetTypographyContent({
              content: t("createAccount.password.requirements.number"),
              size: "small",
              textColor: "greyBase",
            })}
          </CreateAccountPasswordRequirmentsRow>
        </CreateAccountPasswordRequirmentsContainer>
      </CreateAccountPasswordRequirmentsTitle>
    </>
  );
};
